import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9 4.5C9 3.67157 9.67157 3 10.5 3H13.5C14.3284 3 15 3.67157 15 4.5V8.25C15 8.64782 15.158 9.02936 15.4393 9.31066L17.25 11.1213C17.5313 11.4027 17.6893 11.7842 17.6893 12.182V13.5H6.31066V12.182C6.31066 11.7842 6.4687 11.4027 6.75 11.1213L8.56066 9.31066C8.84196 9.02936 9 8.64782 9 8.25V4.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 13.5H18.75C19.5784 13.5 20.25 14.1716 20.25 15V16.5C20.25 17.3284 19.5784 18 18.75 18H5.25C4.42157 18 3.75 17.3284 3.75 16.5V15C3.75 14.1716 4.42157 13.5 5.25 13.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 21H16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.25 15.75L11.125 17.25L14.75 14.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgComponent;
